import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { MessageText, ToastService } from 'app/helpers/services/toastService';

@Component({
  selector: 'app-tenant-sp-description',
  templateUrl: './tenant-sp-description.component.html',
  styleUrl: './tenant-sp-description.component.scss',
  standalone: false,
})
export class TenantSpDescriptionComponent implements OnInit {
  tenantId = '';
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    public toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.tenantId = this.route.snapshot.paramMap.get('id')!;
    if (!this.tenantId) {
      return;
    }
    this.http
      .get(`/api/tenants/spdescriptions/${this.tenantId}`)
      .subscribe((x: any) => {
        if (x) {
          this.selectedCategories.forEach((element) => {
            const t = x.find((f: any) => f.key == element.key);
            if (t) {
              element.description = t.description;
            }
          });
          this.selectedCategoriesDepartment.forEach((element) => {
            const t = x.find((f: any) => f.key == element.key);
            if (t) {
              element.description = t.description;
            }
          });
          this.selectedCategoriesOperational.forEach((element) => {
            const t = x.find((f: any) => f.key == element.key);
            if (t) {
              element.description = t.description;
            }
          });
        }
      });
  }

  selectedCategories = [
    {
      key: '1.1',
      name: 'Value Proposition / Mission & Purpose',
      description: '',
    },
    { key: '1.1.1', name: 'Segmentation criteria', description: '' },
    { key: '1.1.2', name: 'Dream Customers & ICP', description: '' },
    {
      key: '1.1.3',
      name: 'Sales Philosophy & Preferred Method',
      description: '',
    },

    { key: '1.2', name: 'KPI Model & Commercial Dashboard', description: '' },
    { key: '1.2.1', name: 'Buying Journey Positioning', description: '' },
  ];

  selectedCategoriesDepartment = [
    {
      key: '2.1',
      name: 'The Customer Journey (Buying Journey Map)',
      description: '',
    },
    { key: '2.2', name: 'Sales Process (Activity-Based)', description: '' },

    { key: '2.3', name: 'Pipeline Management', description: '' },
    { key: '2.3.1', name: 'Handover New Biz → After Sales', description: '' },
    {
      key: '2.3.2',
      name: 'Account Plans: Land – Expand – Protect',
      description: '',
    },
    {
      key: '2.3.3',
      name: 'Personas & Stakeholder Motivations',
      description: '',
    },
  ];

  selectedCategoriesOperational = [
    { key: '3.1', name: 'Structure for Customer Meetings', description: '' },
    { key: '3.2', name: 'Objections Bank', description: '' },
    { key: '3.3', name: 'Argument Bank / Selling Points', description: '' },
    { key: '3.4', name: 'Phone Call Scripts', description: '' },
    {
      key: '3.5',
      name: 'Meeting Structure (before/during/after)',
      description: '',
    },
    {
      key: '3.6',
      name: 'Needs Discovery & Qualification Flow',
      description: '',
    },
  ];

  save() {
    this.http
      .post(
        `/api/tenants/spdescriptions/${this.tenantId}`,
        this.selectedCategories
          .concat(this.selectedCategoriesDepartment)
          .concat(this.selectedCategoriesOperational),
      )
      .subscribe({
        complete: () => {
          this.toastService.showSuccess(MessageText.saved);
        },
        error: () => {
          this.toastService.showError(MessageText.error);
        },
      });
  }
}
